import { IconButton, Show, Tooltip } from '@vimeo/bokeh';
import { _3GridTopLayout } from '@vimeo/bokeh-icons';
import { useLayout } from '@vimeo/clip-ui/hooks/use-layout';
import { translate } from '@vimeo/i18n-runtime';

export const LayoutToggle = () => {
  const { isSideModuleOpen } = useLayout();
  const layoutToggleTooltipText = translate('Side by side view');
  const layoutIconTransform = "rotate('90deg')";

  if (isSideModuleOpen) return null;

  return (
    <Show above="xl">
      <LayoutToggleIcon label={layoutToggleTooltipText} transform={layoutIconTransform} />
    </Show>
  );
};

interface LayoutToggleIconProps {
  label: string;
  transform: string;
  onClick?: () => void;
}

export const LayoutToggleIcon = ({ transform, label, onClick }: LayoutToggleIconProps) => (
  <Tooltip label={label} placement="top">
    <IconButton
      aria-label={translate('Layout toggle')}
      icon={<_3GridTopLayout transform={transform} />}
      size="sm"
      variant="tertiary"
      onClick={onClick}
    />
  </Tooltip>
);
